export default function describe(data) {
    const nbItems = data.length;
    const nbKeys = Object.keys(data[0]).length;
    const nbDataPoints = nbItems * nbKeys;
    const dataDescription = {
        nbItems,
        nbKeys,
        nbDataPoints,
    };
    return [dataDescription];
}
//# sourceMappingURL=describe.js.map